enum Language {
    NL = 'nl',
    FR = 'fr',
    EN = 'en',
}

export const defaultLanguages: Language[] = [Language.EN, Language.NL, Language.FR]

export default Language
